(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'stepButtons', {
            templateUrl:  'app/views/partials/widgets/step-buttons.html',
            controller:   StepButtonsController,
            controllerAs: 'vm'
        });

    /**
     * Manipulating tabs of any existing subpages.
     *
     * @param {ng.IScope} $scope
     * @param {LoggerFactory} LoggerFactory
     * @param {SubpagesService} SubpagesService
     * @param {Utils} Utils
     * @param {Object} TEXTS
     */
    function StepButtonsController(
        $scope,
        LoggerFactory,
        SubpagesService,
        Utils,
        TEXTS
    ){
        // Helper members.

        /** @type {angular.IController} */
        var vm = this;

        LoggerFactory.createLogger( 'StepButtonsController' );


        /* ===== EXPOSE ON THE SCOPE ======================================== */
        /* ===== CONTROLLER'S PUBLIC API ==================================== */

        // Members (+ their defaults)
        vm.prevState = undefined;
        vm.nextState = undefined;





        /* ===== RUN ON INSTANTIATION ======================================= */

        /** @constructor */
        vm.$onInit = function() {
            setWatchers();
        };





        /* ===== CONTROLLER'S PUBLIC METHODS ================================ */
        /* ===== PRIVATE FUNCTIONS ========================================== */

        function setWatchers() {
            // One-time binding watch
            var subpagesListenerDeregistration = $scope.$watch(
                function() {
                    return SubpagesService.currentSubpages;
                },
                /** @param {uirouter.StateDeclaration[]} newAvailableStates */
                function( newAvailableStates ) {
                    if ( newAvailableStates ) {
                        generateButtonsForCurrentSubpage( newAvailableStates );
                        subpagesListenerDeregistration();
                    }
                }
            );
        }


        /**
         * @param {uirouter.StateDeclaration[]} allAvailableStates
         */
        function generateButtonsForCurrentSubpage( allAvailableStates ) {
            // Make previous/next button available on a template (if there's a page)
            /** @type {{previousSibling:uirouter.StateDeclaration, nextSibling:uirouter.StateDeclaration}} */
            var currentStatesSiblings = SubpagesService.getCurrentSubpageSiblings( allAvailableStates );

            vm.prevState = currentStatesSiblings.previousSibling;
            vm.nextState = currentStatesSiblings.nextSibling;

            // Attach static texts
            if ( vm.prevState ) {
                vm.prevState.description = TEXTS.GENERIC.BUTTONS.PREVIOUS_LABEL;
                vm.prevState.titleMeta   = Utils._( TEXTS.GENERIC.BUTTONS.PREVIOUS_TITLE,  vm.prevState.data.subpage.stepButton.label );
            }
            if ( vm.nextState ) {
                vm.nextState.description = TEXTS.GENERIC.BUTTONS.NEXT_LABEL;
                vm.nextState.titleMeta   = Utils._( TEXTS.GENERIC.BUTTONS.NEXT_TITLE, vm.nextState.data.subpage.stepButton.label );
            }
        }
    };


    StepButtonsController.$inject = [ '$scope', 'LoggerFactory', 'SubpagesService', 'Utils', 'TEXTS' ];
})();
